var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    [
      _c(
        "b-row",
        [
          !_vm.mostrarTextoGenerarPdf &&
          !_vm.isMovimientosVigencias &&
          !_vm.isAyudantes
            ? _c("b-card", [
                _c("h3", {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("formalizacion.mensajeSeccionFormalizacion")
                    ),
                  },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.mostrarTextoGenerarPdf &&
          _vm.isMovimientosVigencias &&
          !_vm.isAyudantes &&
          !_vm.isMovimientoVigenciaCargoAdmvo
            ? _c("b-card", [
                _c("h3", {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t(
                        "formalizacion.mensajeSeccionFormalizacionVigencias"
                      )
                    ),
                  },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.mostrarTextoGenerarPdf &&
          _vm.isMovimientosVigencias &&
          !_vm.isAyudantes &&
          _vm.isMovimientoVigenciaCargoAdmvo
            ? _c("b-card", [
                _c("h3", {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t(
                        "formalizacion.mensajeSeccionNoFormalizacionVigencias"
                      )
                    ),
                  },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isAyudantes &&
          !_vm.mostrarTextoGenerarPdf &&
          !_vm.isMovimientosVigencias
            ? _c("b-card", [
                _c("h3", {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t(
                        "formalizacion.mensajeSeccionFormalizacionAyudantes"
                      )
                    ),
                  },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.mostrarTextoGenerarPdf &&
          !_vm.isMovimientosVigencias &&
          !_vm.isAyudantes
            ? _c(
                "b-col",
                [
                  _c(
                    "b-card",
                    [
                      _c("h3", {
                        domProps: {
                          textContent: _vm._s(_vm.$t("formalizacion.oficio")),
                        },
                      }),
                      _vm._v(" "),
                      !_vm.mostrarBotonUrlDocumentoOficio()
                        ? _c(
                            "b-row",
                            [
                              _c("b-col", [
                                _c("div", { staticClass: "title-block" }, [
                                  _c(
                                    "h4",
                                    { staticClass: "title mt-4 text-center" },
                                    [
                                      _c("span", {
                                        staticClass: "sparkline bar",
                                        attrs: { "data-type": "bar" },
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "formalizacion.mensajeOficio"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.mostrarBotonUrlDocumentoOficio()
                        ? _c(
                            "b-row",
                            { staticClass: "justify-content-center" },
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "auto" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        variant: "outline-secondary",
                                        href: _vm.urlOficio,
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t("formalizacion.verOficio")
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("b-icon-file-earmark-pdf-fill", {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            modifiers: { hover: true },
                                          },
                                        ],
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.mostrarTextoGenerarPdf &&
          !_vm.noAprobado &&
          _vm.mostrarSeccionReconocimiento &&
          !_vm.isAyudantes
            ? _c(
                "b-col",
                [
                  _c(
                    "b-card",
                    [
                      _c("h3", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("formalizacion.reconocimiento")
                          ),
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          !_vm.mostrarBotonUnaFirmaReconocimiento &&
                          !_vm.mostrarBotonUrlDocumentoReconocimiento()
                            ? _c("b-col", [
                                _c("div", { staticClass: "title-block" }, [
                                  _c(
                                    "h4",
                                    { staticClass: "title mt-4 text-center" },
                                    [
                                      _c("span", {
                                        staticClass: "sparkline bar",
                                        attrs: { "data-type": "bar" },
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "formalizacion.mensajeReconocimiento",
                                              {
                                                estado:
                                                  _vm.obtenerEstadoReconocimiento(),
                                              }
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.mostrarBotonUnaFirmaReconocimiento
                            ? _c(
                                "b-col",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "move-right",
                                      attrs: {
                                        variant: "primary",
                                        size: "md",
                                        disabled: _vm.show || _vm.pdfFirma,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.generarVisualizar(
                                            _vm.solicitudDocumentos.id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm.show
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "global.process.load.generando"
                                                )
                                              )
                                            ),
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "entity.action.vistaPrevia"
                                                )
                                              )
                                            ),
                                          ]),
                                      _vm._v(" "),
                                      _c("b-icon", {
                                        staticClass: "mr-2",
                                        attrs: { icon: "binoculars" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.mostrarBotonUnaFirmaReconocimiento,
                                  expression:
                                    "mostrarBotonUnaFirmaReconocimiento",
                                },
                              ],
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "move-right",
                                  attrs: {
                                    variant: "outline-primary",
                                    disabled: _vm.show || _vm.pdfFirma,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.mostrarModalPasswordDocumentoIndividual()
                                    },
                                  },
                                },
                                [
                                  _vm.pdfFirma
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "global.process.load.generando"
                                            )
                                          ) + " "
                                        ),
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "formalizacion.firmarDocumento"
                                              )
                                            )
                                        ),
                                      ]),
                                  _vm._v(" "),
                                  _c("b-icon", { attrs: { icon: "pen-fill" } }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.mostrarBotonUrlDocumentoReconocimiento()
                            ? _c(
                                "b-col",
                                { staticClass: "line-break text-center" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        variant: "outline-secondary",
                                        href: _vm.urlReconocimiento,
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "formalizacion.verReconocimiento"
                                            )
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("b-icon-file-earmark-pdf-fill", {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            modifiers: { hover: true },
                                          },
                                        ],
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.mostrarTextoGenerarPdf &&
          !_vm.noAprobado &&
          _vm.mostrarSeccionConvenio &&
          _vm.mostrarSeccionReconocimiento
            ? _c(
                "b-col",
                [
                  _c(
                    "b-card",
                    [
                      _c("h3", {
                        domProps: {
                          textContent: _vm._s(_vm.$t("formalizacion.convenio")),
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          !_vm.mostrarBotonUnaFirmaConvenio &&
                          !_vm.mostrarBotonDosFirmasConvenio &&
                          !_vm.mostrarBotonUrlDocumentoConvenio &&
                          !_vm.mostrarBotonFirmaSolicitante
                            ? _c("b-col", [
                                _c("div", { staticClass: "title-block" }, [
                                  _c(
                                    "h4",
                                    { staticClass: "title mt-4 text-center" },
                                    [
                                      _c("span", {
                                        staticClass: "sparkline bar",
                                        attrs: { "data-type": "bar" },
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "formalizacion.mensajeConvenio",
                                              {
                                                estado:
                                                  _vm.obtenerEstadoConvenio(),
                                              }
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.mostrarBotonUnaFirmaConvenio
                            ? _c(
                                "b-col",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "move-right",
                                      attrs: {
                                        variant: "primary",
                                        size: "md",
                                        disabled: _vm.show || _vm.pdfFirma,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.generarVisualizar(
                                            _vm.solicitudDocumentos.id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm.show
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "global.process.load.generando"
                                                )
                                              )
                                            ),
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "entity.action.vistaPrevia"
                                                )
                                              )
                                            ),
                                          ]),
                                      _vm._v(" "),
                                      _c("b-icon", {
                                        staticClass: "mr-2",
                                        attrs: { icon: "binoculars" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.mostrarBotonUnaFirmaConvenio,
                                  expression: "mostrarBotonUnaFirmaConvenio",
                                },
                              ],
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "move-right",
                                  attrs: {
                                    variant: "outline-primary",
                                    disabled: _vm.show || _vm.pdfFirma,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.mostrarModalPasswordDocumentoIndividual()
                                    },
                                  },
                                },
                                [
                                  _vm.pdfFirma
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "global.process.load.generando"
                                            )
                                          ) + " "
                                        ),
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "formalizacion.firmarDocumento"
                                              )
                                            )
                                        ),
                                      ]),
                                  _vm._v(" "),
                                  _c("b-icon", { attrs: { icon: "pen-fill" } }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.mostrarBotonFirmaSolicitante,
                                  expression: "mostrarBotonFirmaSolicitante",
                                },
                              ],
                              staticClass: "line-break text-center",
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "move-center",
                                  attrs: {
                                    variant: "primary",
                                    size: "md",
                                    disabled: _vm.show || _vm.pdfFirma,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.generarVisualizar(
                                        _vm.solicitudDocumentos.id
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm.show
                                    ? _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "global.process.load.generando"
                                            )
                                          ),
                                        },
                                      })
                                    : _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "formalizacion.verConvenioFirmaSolicitante"
                                            )
                                          ),
                                        },
                                      }),
                                  _vm._v(" "),
                                  _c("b-icon-file-earmark-pdf-fill", {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true },
                                      },
                                    ],
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.mostrarBotonDosFirmasConvenio
                            ? _c(
                                "b-col",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "move-right",
                                      attrs: {
                                        variant: "primary",
                                        size: "md",
                                        disabled: _vm.show || _vm.pdfFirma,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.generarVisualizar(
                                            _vm.solicitudDocumentos.id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm.show
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "global.process.load.generando"
                                                )
                                              )
                                            ),
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "entity.action.vistaPrevia"
                                                )
                                              )
                                            ),
                                          ]),
                                      _vm._v(" "),
                                      _c("b-icon", {
                                        staticClass: "mr-2",
                                        attrs: { icon: "binoculars" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.mostrarBotonDosFirmasConvenio,
                                  expression: "mostrarBotonDosFirmasConvenio",
                                },
                              ],
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "move-right",
                                  attrs: {
                                    variant: "outline-primary",
                                    disabled: _vm.show || _vm.pdfFirma,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.mostrarModalPasswordDocumentoIndividual()
                                    },
                                  },
                                },
                                [
                                  _vm.pdfFirma
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "global.process.load.generando"
                                            )
                                          ) + " "
                                        ),
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "formalizacion.firmarDocumento"
                                              )
                                            )
                                        ),
                                      ]),
                                  _vm._v(" "),
                                  _c("b-icon", { attrs: { icon: "pen-fill" } }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.mostrarBotonUrlDocumentoConvenio
                            ? _c(
                                "b-col",
                                { staticClass: "line-break text-center" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        variant: "outline-secondary",
                                        href: _vm.urlconvenio,
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t("formalizacion.verConvenio")
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("b-icon-file-earmark-pdf-fill", {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            modifiers: { hover: true },
                                          },
                                        ],
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-3" },
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-modal",
                    {
                      ref: "modal",
                      attrs: {
                        title: _vm.$t("bandeja.generarDoc"),
                        "ok-title": _vm.$t("documentos.modalButtonOk"),
                        "cancel-title": _vm.$t("documentos.modalButtonCancel"),
                      },
                      on: {
                        ok: function ($event) {
                          return _vm.generarDocumento($event)
                        },
                      },
                    },
                    [
                      _c(
                        "form",
                        { ref: "form" },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "global.menu.entities.passwordDocumento"
                                ),
                                "label-for": "name-input",
                                "invalid-feedback": _vm.$t(
                                  "documentos.passwordRequerido"
                                ),
                                state: _vm.estadoPassword,
                              },
                            },
                            [
                              _c(
                                "b-input-group",
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      type: _vm.mostrarPassword
                                        ? "text"
                                        : "password",
                                      "aria-placeholder": _vm.$t(
                                        "documentos.passwordPlaceholder"
                                      ),
                                      required: "",
                                      state: _vm.estadoPassword,
                                    },
                                    model: {
                                      value: _vm.password,
                                      callback: function ($$v) {
                                        _vm.password = $$v
                                      },
                                      expression: "password",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-input-group-append",
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName:
                                                "v-b-tooltip.hover.right",
                                              value: _vm.$t(
                                                "documentos.mostrarPassword"
                                              ),
                                              expression:
                                                "$t('documentos.mostrarPassword')",
                                              modifiers: {
                                                hover: true,
                                                right: true,
                                              },
                                            },
                                          ],
                                          on: {
                                            click: function ($event) {
                                              _vm.mostrarPassword =
                                                !_vm.mostrarPassword
                                            },
                                          },
                                        },
                                        [
                                          _c("b-icon", {
                                            attrs: { icon: "eye" },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("visualizador-pdf", {
            attrs: {
              id: "visualizador-solicitud",
              contenidoBase64: _vm.contenidoBase64,
              mostrar: _vm.pdfReady,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }